import { loginState, configState } from "../lib/State";
import axios from "axios";
import get_cid from '../lib/get_cid';

const get_session = async () => {
  const token = localStorage.getItem("token");
  const cid = get_cid();
  let result = await axios.post("/gympass/get_session", {
    token: token,
    cid: cid,
  });
  return result;
};

export default get_session;